import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  GetTermsAndConditionsParams,
  GetTermsAndConditionsResponse,
  ProblemDetails
} from '../../models';

import { useCustomWelcomeClient } from '../../custom-client.tsx';
import type { ErrorType } from '../../custom-client.tsx';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns the terms and conditions link for the specified country and the provided language header.<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding<br>welcome.doka.com/onboarding-backoffice
 */
export const useGetTermsAndConditionsHook = () => {
        const getTermsAndConditions = useCustomWelcomeClient<GetTermsAndConditionsResponse>();

        return useCallback((
    params?: GetTermsAndConditionsParams,
 signal?: AbortSignal
) => {


        return getTermsAndConditions(
          {url: `/terms-and-conditions`, method: 'GET',
        params, signal
    },
          );
        }, [getTermsAndConditions])
      }




export const getGetTermsAndConditionsQueryKey = (params?: GetTermsAndConditionsParams,) => {
    return [
    `/terms-and-conditions`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetTermsAndConditionsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError = ErrorType<ProblemDetails>>(params?: GetTermsAndConditionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTermsAndConditionsQueryKey(params);

  const getTermsAndConditions =  useGetTermsAndConditionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>> = ({ signal }) => getTermsAndConditions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTermsAndConditionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>>
export type GetTermsAndConditionsQueryError = ErrorType<ProblemDetails>


export function useGetTermsAndConditions<TData = Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError = ErrorType<ProblemDetails>>(
 params: undefined |  GetTermsAndConditionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTermsAndConditions<TData = Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError = ErrorType<ProblemDetails>>(
 params?: GetTermsAndConditionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTermsAndConditions<TData = Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError = ErrorType<ProblemDetails>>(
 params?: GetTermsAndConditionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTermsAndConditions<TData = Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError = ErrorType<ProblemDetails>>(
 params?: GetTermsAndConditionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTermsAndConditionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTermsAndConditionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






